<!-- Bouton déclencheur (tu peux le placer où tu veux) -->
<button
  mat-icon-button
  [matMenuTriggerFor]="mainMenu"
  aria-label="Ouvrir le menu"
>
  <mat-icon fontSet="material-symbols-outlined">menu</mat-icon>
</button>

<!-- Menu racine -->
<mat-menu #mainMenu="matMenu" xPosition="after" yPosition="below">
  <app-menu-branch [items]="items" [roles]="roles"></app-menu-branch>
</mat-menu>
